import { ParametersDefaults } from "./type.mjs";
import { PriceType, defaults } from "./util.mjs";
//#region src/base.ts
const GenerationModelTypeSubSet = {
	SdxlModel: "SDXL_MODEL",
	Sd3MediumModel: "SD3_MEDIUM_MODEL"
};
var BasePricing = class {
	meter;
	parameters;
	config;
	constructor(parameters, config) {
		this.parameters = defaults(ParametersDefaults, parameters);
		this.config = config;
		this.meter = this.getNewPriceMeter();
	}
	getNewPriceMeter = () => {
		const items = [];
		return {
			type: PriceType.prepaid,
			items,
			curPrice: 0,
			discount: 0,
			addItem(cumulative, { name, ...item } = {}) {
				const totalPrice = Math.trunc(cumulative(this.curPrice) - this.curPrice);
				if (name != null) items.push({
					name,
					spec: "",
					...item,
					totalPrice
				});
				this.curPrice += totalPrice;
				if (totalPrice < 0) this.discount -= totalPrice;
			},
			addResult(result) {
				if (result) this.addItem(result.cumulative, result.item);
			},
			toPriceInfo() {
				return {
					type: this.type,
					items,
					originalPrice: Math.max(0, this.curPrice + this.discount),
					actualPrice: Math.max(0, this.curPrice)
				};
			}
		};
	};
};
//#endregion
export { BasePricing, GenerationModelTypeSubSet };
